module.exports = __webpack_public_path__ + "static/flags/ML-5fbf552b4cf36823562688f079fd5244.gif";